import React from 'react';
import styled, { withTheme } from 'styled-components';
import { MaxWidthLayoutDesktop } from '../../../templates/MaxWidthLayout';
import FullLayout from '../../../templates/FullLayout';
import CategoriesNavSlot from './CategoriesNavSlot';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import NavigationMediaQueryHelper from '../../../templates/NavigationMediaQueryHelper';
import { MOBILE_ONLY } from '../../../../lib/constants';
import { isUserLoggedIn } from '../../../../lib/user';


const NavSlotRowDiv = styled.div``;

const NavigationCategoriesBarDiv = styled.div`
  height: 72px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  
  > div > span:first-child {
    margin-left: 0;
  }
`;

const BoxShadowDiv = styled.div`
  position: relative;
  width: 100%;
  box-shadow: 0 1px 0 0 ${p => p.theme.c.border['box-shadow']};
`;

const NavigationCategoriesBar = withTheme(({
  userShopsData,
  firstNavSlots = [],
  secondNavSlots = [],
  anonFirstNavSlots = [],
  anonSecondNavSlots = [],
  userData,
  locale,
  linkOneUrl,
  linkOneText,
  linkOneAnalyticsSlug,
  linkOneTagSet,
  linkTwoUrl,
  linkTwoText,
  linkTwoAnalyticsSlug,
  linkTwoTagSet,
  myZoneDropdownTitle,
  pageStateModifiers,
  globalPageConfig,
  moreDropdownTitle,
}) => {
  const categoriesDropdownLinks = [];
  if (linkOneUrl && linkOneText) {
    categoriesDropdownLinks.push({
      url: linkOneUrl,
      text: linkOneText,
      analyticsSlug: linkOneAnalyticsSlug,
      tags: linkOneTagSet,
    });
  }
  if (linkTwoUrl && linkTwoText) {
    categoriesDropdownLinks.push({
      url: linkTwoUrl,
      text: linkTwoText,
      analyticsSlug: linkTwoAnalyticsSlug,
      tags: linkTwoTagSet,
    });
  }

  const firstNavSlotsToUse = (isUserLoggedIn(userData) ? firstNavSlots : anonFirstNavSlots).filter(slot => slot.navSlotPurpose !== MOBILE_ONLY);
  const secondNavSlotsToUse = (isUserLoggedIn(userData) ? secondNavSlots : anonSecondNavSlots).filter(slot => slot.navSlotPurpose !== MOBILE_ONLY);
  const {
    visitInfo,
    collectorNumber,
  } = userData;
  const {
    firstName = '',
  } = visitInfo || {};

  const firstNavSlotsRender = (firstNavSlots, hideAnchors) => (
    <NavSlotRowDiv id='firstCategoryBar'>
      {firstNavSlots && firstNavSlots.map(
        (slot, index) => {
          const {
            text = '',
          } = slot;

          const key = `nav-slot${text}-${index}`;

          return (
            <CategoriesNavSlot
              {...slot}
              key={key}
              collectorNumber={collectorNumber}
              firstName={firstName}
              locale={locale}
              userShopsData={userShopsData}
              myZoneDropdownTitle={myZoneDropdownTitle}
              categoriesDropdownLinks={categoriesDropdownLinks}
              pageStateModifiers={pageStateModifiers}
              hideAnchors={hideAnchors}
              globalPageConfig={globalPageConfig} />
          );
        })
      }
    </NavSlotRowDiv>
  );

  const secondNavSlotsRender = (secondNavSlots, hideAnchors) => (
    <NavSlotRowDiv id='secondCategoryBar'>
      {secondNavSlots && secondNavSlots.map(
        slot => {
          const {
            text = '',
          } = slot;

          return (<CategoriesNavSlot
            key={`nav-slot${text}`}
            {...slot}
            userShopsData={userShopsData}
            myZoneDropdownTitle={myZoneDropdownTitle}
            collectorNumber={collectorNumber}
            firstName={firstName}
            locale={locale}
            hideAnchors={hideAnchors}
            pageStateModifiers={pageStateModifiers} />);
        },
      )}
    </NavSlotRowDiv>);

  const renderDesktopBody = (firstNavSlots, secondNavSlots, hideAnchors) => (
    <NavigationCategoriesBarDiv id='navBar'>
      <NavSlotRowDiv>
        {firstNavSlotsRender(firstNavSlots, hideAnchors)}
      </NavSlotRowDiv>

      <NavSlotRowDiv>
        {secondNavSlotsRender(secondNavSlots, hideAnchors)}
      </NavSlotRowDiv>
    </NavigationCategoriesBarDiv>
  )

  const DesktopBody = (
    <FullLayout>
      <BoxShadowDiv>
        <MaxWidthLayoutDesktop>

          <NavigationMediaQueryHelper
            moreText={moreDropdownTitle}
            firstNavSlots={firstNavSlotsToUse}
            secondNavSlots={secondNavSlotsToUse}
            renderDesktopBody={renderDesktopBody} />

        </MaxWidthLayoutDesktop>
      </BoxShadowDiv>
    </FullLayout>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={DesktopBody}
      mobileChildren={null} />);
  return renderComp;
});

export default NavigationCategoriesBar;
